export const MenuSeparator = () => <li className="sidebar-separator" />;
